import { ENDPOINTS } from "../constants/ApiEndPoints";
import { postService } from "../services/ApiServices";

export const getAuthTokenAPI = async (requestBody) => {
  try {
    const response = await postService(`${ENDPOINTS.OAUTH_TOKEN}`, requestBody);
    if (response?.access_token) {
      return response?.access_token;
    }
  } catch (error) {
    console.error("something went wrong", error);
  }
};
